import { render } from "./NewMatchBox.vue?vue&type=template&id=7f5b038d&scoped=true"
import script from "./NewMatchBox.vue?vue&type=script&lang=js"
export * from "./NewMatchBox.vue?vue&type=script&lang=js"

import "./NewMatchBox.vue?vue&type=style&index=0&id=7f5b038d&scoped=true&lang=css"

import exportComponent from "/Users/georgeconstantine/Documents/import/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f5b038d"]])

export default __exports__